export const trimZeroes = (ref: React.RefObject<HTMLInputElement | null>) => {
  if (!ref.current) return;

  const { value } = ref.current;
  if (value.length > 1 && /^0/.test(value)) {
    // eslint-disable-next-line no-param-reassign
    ref.current.value = value.replace(/^0/, '');
  }
};
